export default class VeiculoViagemDashboardFilters {
    inicioPeriodo: Date | null;
    fimPeriodo: Date | null;

    constructor(inicioPeriodo: Date | null = null, fimPeriodo: Date | null = null) {
        this.inicioPeriodo = inicioPeriodo;
        this.fimPeriodo = fimPeriodo;
    }

}